/*
 * Deckstate.js
 *
 * Initialisation of deck page state.
 * Loads deck and containers for vessel / rig
 *
 */

/*
 * Initialises the deck planning section
 */
function InitialiseDeckPlanning () {

	InitialiseDialogs(G_PAGE['DECK_PAGE']);

	PopulateContainerTypeList();

	SetManifestLocations();

	SetDefaultContainerDataList();

	LoadLocalDeckState();

	SetInitialManifestLocation();

	for (var l_key in g_container_list) {
		g_container_list[l_key].InitialiseVisual(G_CONTAINING_DIV);
	}

	// Check what status of ctrl key is
	$(document).keydown(function (p_e) {
      if (p_e.keyCode == 17) {
          g_ctrl_key_down = true;
      }
	});
	$(document).keyup(function (p_e) {
      if (p_e.keyCode == 17) {
          g_ctrl_key_down = false;
      }
	});

	$('#container_default_type').change(function () {
		var params = ($(this).val()).split(';');
		$('#container_tag').val(params[0]);
		$('#container_length').val(params[1]);
		$('#container_width').val(params[2]);
		if (params[3] !== undefined && $('#container_type').val(params[3]) !== undefined) {
			$('#container_type').val(params[3]);
		}
	});

	UpdateAllDeckTotals();

	SetInputNumbersOnly('#container_width');
	SetInputNumbersOnly('#container_length');
	SetInputNumbersOnly('#container_weight');

	$('#AutoSaveDeckBox').val('');

	if (g_autoupdate_deck === true) {
		$("#AutoSaveDeckBox").prop('checked', true);
	}
	else {
		$("#AutoSaveDeckBox").prop('checked', false);
	}
	SetAutoSaveDeck();

}

/*
 * On leaving page
 */
function OnLeavingDeckPage () {
	SaveLocalState();
	DestroyDialogs(g_current_page);
}

/******************************************************************************************
 * Dropdown list population
 *******************************************************************************************/

/*
 * Populates container list based on edit mode
 */
function PopulateContainerTypeList () {
	$('#container_type').html('');
	$.each(g_master_data.GetList('container_type_list'), function (p_index, p_value) {
		$('#container_type').append($("<option />").val(p_value.id).text(p_value.name));
	});
}

/*
 * Populates the manifest locations for deck, sorted by rig and deck
 * and then sets the callback functions
 */
function SetManifestLocations () {

	var $portSelection = $('#port_selection');
	var $containerDestination = $('#container_destination');
	var $contarinerOrigin = $('#container_origin');
	var ctx = VRC.MasterDataService.getGroupedPorts();
	var portHtml = Handlebars.partials['port_selectlist'](ctx);

	$portSelection.html(portHtml);

	ctx.placeHolder = {
		value: '',
		text: '-- Select Destination --'
	};

	portHtml = Handlebars.partials['port_selectlist'](ctx);
	$containerDestination.html(portHtml);

	ctx.placeHolder = {
		value: '',
		text: '-- Select Origin --'
	};

	portHtml = Handlebars.partials['port_selectlist'](ctx);
	$contarinerOrigin.html(portHtml);

	$portSelection.change(function () {
		$('#port_selection option:selected').each(function () {

			if ($(this).val()) {
				var $l_this = $(this);
				g_data_list['source'] = $l_this.val();
				$('#transit_area_text').text($l_this.text());
				VRC.ErrorHandleService.showMessage('Current manifest location changed to: ' + $l_this.text(), G_MSG_TYPE_NORMAL);
			}

		});
	});

	$portSelection.selectize(VRC.Utils.Selectize.getConfig());
	$containerDestination.selectize(VRC.Utils.Selectize.getConfig());
	$contarinerOrigin.selectize(VRC.Utils.Selectize.getConfig());
}

/*
 * Sets the initial manifest location from the dropdown list
 */
function SetInitialManifestLocation () {
	if (g_data_list['source'] === undefined) {
		$('#port_selection').val($('#port_selection option:first').val());
		g_data_list['source'] = $('#port_selection option:first').val();
	}
	else {
		$('#port_selection').val(g_data_list['source']);
	}
	$('#transit_area_text').text($('#port_selection option:selected').text());
}

/*
 * Sets the default container types from master data
 */
function SetDefaultContainerDataList () {
	var cnt_type_list = g_master_data.GetList('container_default_unit_list');

	$('#container_default_type').html('');

	$('#container_default_type').append('<option value="">-NA-</option>');

	for (var key in cnt_type_list) {
		$('#container_default_type').append('<option value="' + cnt_type_list[key].id + '">' + cnt_type_list[key].name + '</option>');
	}
}

/******************************************************************************************
 * Edit Modes
 *******************************************************************************************/

/*
 * Loads deck state again
 */
function LoadLocalDeckState () {
	ClearAllContainers(false);
	RemoveDecks();

	LoadLocalState();

	// Load deck data
	g_deck_scale = g_data_list['deck_scale_value'];
	InitialiseDecks(g_localsave_object.GetLocalStorageItem(G_LS_NAMES['DECK_DATA']));

	// Load containers
	var l_temp_list = g_localsave_object.GetLocalStorageItem(G_LS_NAMES['DECK_CONTAINER_DATA']);

	var l_counter = 0;

	for (var l_key in l_temp_list) {
		g_container_list[l_key] = new container(l_temp_list[l_key], {'new': false});
		g_container_list[l_key].InitialiseVisual(G_CONTAINING_DIV);

	}
	UpdateColorMap();
	UpdateAllDeckTotals();
	VRC.ErrorHandleService.showMessage('Succesfully loaded decks and (' + l_counter + ') containers  from local storage', G_MSG_TYPE_SUCCESS);
}

var UpdateColorMap = function () {

	var l_colour_list = {};

	var l_port_list = g_master_data.GetList('port_list');

	$.each(g_container_list, function (key, container) {
		var containerColor = {};
		var suffix = "";

		if (container.deckID !== "outgoing_area") {
			for (var ii = 0; ii < l_port_list.length; ii++) {
				var port = l_port_list[ii];
				if (port.id == container.destination && port.type == 'rig') {
					containerColor.destination = port.name + suffix;
				}
				else if (port.id == container.origin && port.type == 'rig') {
					containerColor.origin = port.name + suffix;
				}
			}
			if (containerColor.destination) {
				l_colour_list[containerColor.destination] = container.colour;
			}
			else if (containerColor.origin) {
				l_colour_list[containerColor.origin] = container.colour;
			}
			;
		}
		else {
			container.colour = "#FF5349";
			l_colour_list["Offloading Area"] = container.colour;
		}
	});
  var $colour_codes = $('#colour_codes');
	$colour_codes.html('');

	for (var l_key in l_colour_list) {
		$colour_codes.append('<div class="colour_code_block" style="background-color:' + l_colour_list[l_key] + '">' + l_key + '</div>');
	}
};

/*******************************************************************************
 Functions for clearing / resetting containers
 ********************************************************************************/

/*
 * Clears the vessel/port deck from containers and places them in the transit area
 */
function ClearVesselDeck () {
	var l_i = 5;
	var increment = 0.2;
	for (var l_key in g_container_list) {
		var l_old_container = g_container_list[l_key];
		if (l_old_container.deckID != 'transit_area' && l_old_container.deckID != 'outgoing_area' && l_old_container.type != 'constraint') {

        if (l_old_container.properties.roundtrip || l_old_container.properties.storage) {
            continue;
        }

			l_old_container.deckID = 'outgoing_area';

			l_old_container.position.x = ((GetCurrentDeckLength() / 100) * (62 + increment));
			l_old_container.position.y = ((GetDeckAreaHeight() + increment) - GetCurrentDeckWidth());
			l_old_container.colour = G_CONTAINER_COLOURS['OUTGOING'];
			g_container_list[l_key] = l_old_container;
			g_container_list[l_key].UpdateContainerVisual();
			l_i += 10;
			increment += 0.2;
		}
	}
	UpdateAllDeckTotals();
	UpdateColorMap();
}

/*
 * Lets user confirm whether deck should be cleared for containers
 */
function ConfirmClearDeck () {
	var msg = 'This will remove all containers from deck. Confinue?';
	var onConfirm = function () {
		ClearVesselDeck();
		VRC.ErrorHandleService.showMessage('Deck cleared of containers, except for roundtrip containers', G_MSG_TYPE_NORMAL);
	};
	VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});

}

/*
 * Lets user confirm whether all containers should be removed
 */
function ConfirmClearAllContainers () {

	var msg = 'This will remove all containers. Confinue?';

	var onConfirm = function () {
		ClearAllContainers();
		VRC.ErrorHandleService.showMessage('All containers removed', G_MSG_TYPE_NORMAL);
	};
	VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
}

/*
 * Clears ALL containers from page. Local storage is not affected
 */
function ClearAllContainers (update) {
	if (update === undefined) {
		update = true;
	}
	$('.deckstate_container').remove();
	g_container_list = {};
	if (update) {
		UpdateAllDeckTotals();
		UpdateColorMap();
	}
}

/*
 * Removes all decks from page and list
 */
function RemoveDecks () {
	for (var l_key in g_deck_list) {
		$('#' + g_deck_list[l_key].id).remove();
	}

	$('#transit_area').remove();
	$('#outgoing_area').remove();
}

function ConfirmClearOutgoingContainers () {
	var msg = 'This will remove all containers from outgoing area. Confinue?';
	var onConfirm = function () {
		RemoveOutgoingContainers();
		VRC.ErrorHandleService.showMessage('All outgoing containers removed', G_MSG_TYPE_NORMAL);
	};
	VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
}

/*
 * Removes containers in the outgoing area
 */
function RemoveOutgoingContainers () {
	for (var l_key in g_container_list) {
		if (g_container_list[l_key].deckID == 'outgoing_area') {
			$('#' + g_container_list[l_key].id).remove();
			delete g_container_list[l_key];
		}
	}
}

/*
 * Puts all containers on transit area that are not already
 * on the vessel's deck and updates containers to roundtrip
 */
function PopulateTransitContainers (p_data) {
	var l_counter = 0;

	var containers = p_data.WELS_container_data;

	var transitContainers = _.filter(containers, function (container) {

		return $('#' + container.id).length === 0 && g_container_list[container.prev_id] === undefined;
	});

	var blocks = _.map(transitContainers, function (c) {
		c.h = parseFloat(c.features.width);
		c.w = parseFloat(c.features.length);
		return c;
	});

	blocks.sort(function (a, b) {
		return (b.w > a.w);
	});

	var packer = new GrowingPacker(GetCurrentDeckLength(), GetCurrentDeckWidth());
	packer.fit(blocks);

	for (var n = 0; n < blocks.length; n++) {
		var block = blocks[n];

		if (block.fit) {
			block.deckID = 'transit_area';
			block.position.x = block.fit.x;
			block.position.y = block.fit.y + GetCurrentDeckWidth() + 1;

			g_container_list[block.id] = new container(block, {'new': false});
			g_container_list[block.id].InitialiseVisual(G_CONTAINING_DIV);
		}
	}

	$.each(containers, function () {
		if ($('#' + this.id).length == 0) {

			if (g_container_list[this.prev_id] !== undefined) {
				SetContainerAsRoundtrip(this);
			}
			else {
				l_counter++;
			}
		}
		else {
			g_container_list[this.id].features.length = this.features.length;
			g_container_list[this.id].features.width = this.features.width;
			g_container_list[this.id].features.weight = this.features.weight;
			g_container_list[this.id].dg_info = this.dg_info;
			g_container_list[this.id].dg_class = this.dg_class;
			g_container_list[this.id].remarks = this.remarks;
			g_container_list[this.id].properties = this.properties;
			g_container_list[this.id].origin = this.origin;
			g_container_list[this.id].destination = this.destination;
			g_container_list[this.id].type = this.type;
			g_container_list[this.id].tag = this.tag;
			g_container_list[this.id].UpdateContainerVisual();
		}
	});

	return l_counter;
}

/*
 * Container from manifest already exists on deck and is actually going as roundtrip.
 * Just replace key values from old container with new
 */
function SetContainerAsRoundtrip (p_roundtrip_container) {
	var old_container_data = g_container_list[p_roundtrip_container.prev_id];

	p_roundtrip_container.position = old_container_data.position;
	p_roundtrip_container.features.rotation = old_container_data.features.rotation;
	p_roundtrip_container.deckID = old_container_data.deckID;

	g_container_list[p_roundtrip_container.id] = new container(p_roundtrip_container, {'new': false});
	g_container_list[p_roundtrip_container.id].InitialiseVisual(G_CONTAINING_DIV);

	g_container_list[p_roundtrip_container.prev_id].DeleteContainerVisual();
	delete g_container_list[p_roundtrip_container.prev_id];
}

/*
 * Search containers and highlight
 */
function HighlightContainers (clearSearch) {
	$('.deckstate_container').toggleClass('highlighted', false);

	if (clearSearch == 'clear') {
		$('#container_search_input').val('');
		return;
	}

	var searchStr = $('#container_search_input').val();
	searchStr = searchStr.toLowerCase();
	var regExString = RegExp(searchStr, 'g');
	$('.deckstate_container').each(function () {
		if (this.innerText.toLowerCase().match(regExString)) {
			$(this).toggleClass('highlighted', true);
		}
	});
}

/*******************************************************************************
 Functions for creating / adding containers to local
 storage or divs
 ********************************************************************************/

/*
 * Reads values from container and sets those values into form
 */
function SetContainerData (p_id) {

	$('#container_id').attr("disabled", true);

	// if id is null or undefined, we are creating a new container
	if (p_id === undefined) {
		$("#container_type").val('container');
		$('#container_tag').attr('disabled', false);

		$('#container_count').attr('disabled', false);
		$('#container_count').val(1);

		// Set container data based on selected port
		var l_port_id = $('#port_selection option:selected').val();
		$('#container_origin').val(l_port_id);
		var l_port_list = g_master_data.GetList('port_list');
		for (l_key in l_port_list) {
			if (l_port_list[l_key].id == l_port_id && l_port_list[l_key].type == 'rig') {
				$('#container_backload').prop('checked', true);
				break;
			}
		}
		return;
	}
	else {
		$('#container_count').val(1);
		$('#container_count').attr('disabled', true);
	}

	$('#container_id').val(g_container_list[p_id].id);
	$('#container_tag').val(g_container_list[p_id].tag);

	if (g_container_list[p_id].id.indexOf('container_') > -1) {
		$('#container_tag').attr('disabled', false);
	}
	else {
		$('#container_tag').attr('disabled', true);
	}

	$('#container_remarks').val(g_container_list[p_id].remarks);
	$('#container_type').val(g_container_list[p_id].type);

	$('#container_origin')[0].selectize.setValue(g_container_list[p_id].origin);
	$('#container_destination')[0].selectize.setValue(g_container_list[p_id].destination);

	$('#container_length').val(g_container_list[p_id].features.length);
	$('#container_width').val(g_container_list[p_id].features.width);
	$('#container_weight').val(g_container_list[p_id].features.weight);

	$('#container_priority').prop('checked', g_container_list[p_id].properties.priority);
	$('#container_dangerous').prop('checked', g_container_list[p_id].properties.dangerous);
	$('#container_roundtrip').prop('checked', g_container_list[p_id].properties.roundtrip);
	$('#container_backload').prop('checked', g_container_list[p_id].properties.backload);
	$('#container_storage').prop('checked', g_container_list[p_id].properties.storage);
	$('#container_transfer').prop('checked', g_container_list[p_id].properties.transfer);
}

/*
 * Creates a new container or updates a pre-existing one
 */
function CreateNewContainer () {
	var l_id = $('#container_id').val();

	var l_count = $('#container_count').val();
	if (isNaN(l_count) || l_count < 1) {
		l_count = 1;
	}
	if (l_count > 10) {
		var msg = 'You cannot create more than 10 containers at once.';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
		return;
	}
	var prev_pos = null;
	var prev_deck_id = null;
	for (var i = 0; i < l_count; i++) {
		var created_id = CreateOrUpdateContainer(l_id);

		if (created_id) {
			if (prev_pos) {
				g_container_list[created_id].deckID = prev_deck_id;
				g_container_list[created_id].ChangePosition(prev_pos.x + 0.1, prev_pos.y + 0.1);
			}
			prev_pos = g_container_list[created_id].position;
			prev_deck_id = g_container_list[created_id].deckID;
		}
	}

	CloseContainerDialog();

    if (l_id === undefined || l_id === null) {
        VRC.ErrorHandleService.showMessage('New ad-hoc container created', G_MSG_TYPE_NORMAL);
    } else {
        VRC.ErrorHandleService.showMessage('Container viewed/updated', G_MSG_TYPE_NORMAL);
    }

	UpdateAllDeckTotals();
	UpdateColorMap();
}

/*
 * Creates a new container or updates an existing one
 */
function CreateOrUpdateContainer (p_id) {
	var l_update = true;

	if (p_id === undefined || p_id == '') {
		l_update = false;
	}

	var containerVal = $('#container_weight').val();
	if (containerVal) {
		containerVal = containerVal.replace(',', '.');
	}

	var l_container_data = {
		'tag': $('#container_tag').val(),
		'remarks': $('#container_remarks').val(),
		'origin': $('#container_origin option:selected').val(),
		'destination': $('#container_destination option:selected').val(),
		'type': $('#container_type option:selected').val(),
		'features': {
			'length': $('#container_length').val(),
			'width': $('#container_width').val(),
			'weight': containerVal,
		},
		'properties': {
			'backload': $('#container_backload').is(':checked'),
			'roundtrip': $('#container_roundtrip').is(':checked'),
			'dangerous': $('#container_dangerous').is(':checked'),
			'storage': $('#container_storage').is(':checked'),
			'priority': $('#container_priority').is(':checked'),
			'transfer': $('#container_transfer').is(':checked')
		},
		'position': {
			'x': 0,
			'y': 0
		}
	};

	l_container_data.colour = SetContainerColour(l_container_data);

	if (l_update) {

		var l_old_container = g_container_list[p_id];
		l_old_container.tag = l_container_data.tag;
		l_old_container.type = l_container_data.type;
		l_old_container.remarks = l_container_data.remarks;
		l_old_container.origin = l_container_data.origin;
		l_old_container.destination = l_container_data.destination;
		l_old_container.features.length = l_container_data.features.length;
		l_old_container.features.width = l_container_data.features.width;
		l_old_container.features.weight = l_container_data.features.weight;
		l_old_container.properties.backload = l_container_data.properties.backload;
		l_old_container.properties.roundtrip = l_container_data.properties.roundtrip;
		l_old_container.properties.storage = l_container_data.properties.storage;
		l_old_container.properties.dangerous = l_container_data.properties.dangerous;
		l_old_container.properties.priority = l_container_data.properties.priority;
		l_old_container.properties.transfer = l_container_data.properties.transfer;
		l_old_container.colour = l_container_data.colour;

		l_old_container.UpdateContainerVisual();
		g_container_list[p_id] = l_old_container;

		return null;
	}
	else {
		if (g_dbl_container_pos.length > 0) {
			l_container_data.position.x = g_dbl_container_pos[0];
			l_container_data.position.y = g_dbl_container_pos[1];
			l_container_data.deckID = g_dbl_container_pos[2];
			g_dbl_container_pos = [];

		}
		else {
			var transitAreaPosition = $('#transit_area').position();
			l_container_data.position.x = 0;
			l_container_data.position.y = (GetDeckAreaHeight() - GetCurrentDeckWidth());
			l_container_data.deckID = 'transit_area';

		}
		l_container_data.features.rotation = 0;

		var l_new_container = new container(l_container_data, {'new': true});

		l_new_container.InitialiseVisual(G_CONTAINING_DIV);
		g_container_list[l_new_container.id] = l_new_container;

		return g_container_list[l_new_container.id].id;
	}
}

/*
 * Sets colour on container based on origin/destination
 */
function SetContainerColour (p_container_data) {

	if (p_container_data.origin != null) {
		var l_port_list = g_master_data.GetList('port_list');
		var l_origin = null;
		var l_destination = null;
		for (var i in l_port_list) {
			if (l_port_list[i].id == p_container_data.origin) {
				l_origin = l_port_list[i];
			}
			if (l_port_list[i].id == p_container_data.destination) {
				l_destination = l_port_list[i];
			}
		}
	}

	if (l_destination && l_destination.type == 'rig') {
		return l_destination.colour;
	}
	else if (l_origin && l_origin.type == 'rig') {
		return l_origin.colour;
	}

	return G_CONTAINER_COLOURS['DECK'];
}

/*
 * Fetches last state from database for the deck(s)
 */
function FetchDeckStateFromDB () {
	var isCurrentPage = (g_current_page === G_PAGE.DECK_PAGE);
	var onSuccess;
	var deferred = $.Deferred();

	if (isCurrentPage) {
		onSuccess = function (object, data) {
			ParseContainersAndDisplay(object, data);
			deferred.resolve(object, data);
		};
	}	else {
		 onSuccess = function (object, data) {
			ParseContainers(data.WELS_container_list);
			deferred.resolve(object, data);
		};
	}
	g_remote_object.FetchDeckStateFromDB(g_container_list, onSuccess);
	return deferred.promise();
}

/*
 * Parses containers and shows them
 */
function ParseContainersAndDisplay (p_owner, p_data) {

	$.each(p_data.WELS_container_list, function () {
		g_container_list[this.id] = new container(this, {'new': false});
		g_container_list[this.id].InitialiseVisual(G_CONTAINING_DIV);
	});
	g_localsave_object.SetLocalStorageItem(G_LS_NAMES['DECK_CONTAINER_DATA'], p_data.WELS_container_list);
	UpdateColorMap();
	UpdateAllDeckTotals();
}

/*
 * Parses containers
 */
function ParseContainers (containerList) {

	$.each(containerList, function () {
		g_localsave_object.SetLocalStorageItem(G_LS_NAMES['DECK_CONTAINER_DATA'], containerList);
	});
}

/*
 * Fetches transit containers for a given vessel / port
 */
function FetchTransitContainers () {

	return g_remote_object.FetchTransitContainers();

}

/*
 * Confirms whether we want to fetch new transit containers
 */
function ConfirmFetchTransitContainers () {
	var msg = 'This will fetch containers from selected port. Continue?';
	VRC.ContainerPopoverView.hide();
	var onConfirm = function () {
		var fetchTransit = FetchTransitContainers();
		fetchTransit.done(function () {
			// VRC.ConfirmationModal.hide();

			setTimeout(function () {
				VRC.FindMatchingContainerModal.show()
			}, 500);

		})
	};
	VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
};

/*******************************************************************************
 *  Functions for Tools popup
 *******************************************************************************/
/*
 * Opens up the tools popup
 */
function OpenToolsPopup () {
	g_remote_object.FetchHTMLFromServer(g_container_list, ParseContainerSyncList, 'info', 'tools_sync');
}

function ParseContainerSyncList (p_owner, p_data) {
	$("#deck_tools_popup").html(p_data);
	$("#deck_tools_popup").dialog('open');
}

/*
 * Android Specific function. Placeholder for now?
 */
function TakeDeckPicture () {
	Android.takePicture("deck_state", g_data_list["id"], g_data_list["operator"], "");
}

function DisplayCaptureImageButton (display) {
	if (display) {
		$('#deck_capture_image').css('display', 'inline');
	}
	else {
		$('#deck_capture_image').css('display', 'block');
	}
}
/*
 * Calculates totals for containers that are currently on deck
 */
function CalculateDeckTotals (deckId) {

	var total_mt = 0;

	var count_container_mt = 0;
	var count_container_total = 0;

	_.each(g_container_list, function (container) {
		var containerDeckId = container.deckID;

		if (containerDeckId !== null && containerDeckId == deckId) {

			count_container_total++;
			try {
				var mt = isNaN(parseFloat(container.features.weight, 2)) ? 0 : parseFloat(container.features.weight, 2);
				if (mt > 0) {
					total_mt += mt;
					count_container_mt++;
				}
			}
			catch (e) {
				console.error('Tried to parse' + container.features.weight);
			}
		}
	});

	return {

		mt: total_mt,
		mt_count: count_container_mt,
		mt_missing_count: count_container_total - count_container_mt,
		total_count: count_container_total

	};
}

/*
 * Updates the visual display of container data
 */
function UpdateAllDeckTotals () {
	var $wrapper = $('.container__actions__mt');
	if (g_current_deck) {
		UpdateDeckTotals(g_current_deck.id, $wrapper, 'on deck');
		var $deckMiddleArea = $("#deck__middle_area");
		UpdateDeckTotals('transit_area', $deckMiddleArea, 'in loading area');
	}

}

function UpdateDeckTotals (deckId, $wrapper, deckNameWithPreposition) {
	var result = CalculateDeckTotals(deckId);

	var $mt_total = $wrapper.find('.mt_total');
	var $mt_containers = $wrapper.find('.mt_containers');
	var prefUnits = VRC.MasterDataService.getValueUnitPreferences();

	$mt_total.text('Estimated total weight ' + deckNameWithPreposition + ': ' + result.mt.toFixed(2) + ' ' + prefUnits.weight);

	if (result.mt_missing_count > 0) {
		result.containertext = 'container';
		if (result.mt_missing_count > 1) {
			result.containertext = result.containertext + 's';
		}
		$mt_containers.html(WELL.Handlebars.VRC.missing_container_alert(result));
		$wrapper.find('.missing_containers_btn').click(function (e) {

			VRC.ContainerService.highligthContainersWithoutWeight(deckId)
		});
	}
	else if (result.total_count > 0) {
		$mt_containers.html(WELL.Handlebars.VRC.no_missing_container_alert(result));
	}
	else {
		$mt_containers.html(WELL.Handlebars.VRC.no_container_alert({text: 'No containers ' + deckNameWithPreposition}));
	}

};

function UpdateTransitAreaTotals () {
	var result = CalculateDeckTotals('transit_area');
	var $mt_total = $('#mt_total');
	var $mt_containers = $('#mt_containers');
}

/*
 * Sets whether deck should autosave every 2 minutes
 */
function SetAutoSaveDeck () {

	var is_checked = $('#AutoSaveDeckBox').is(":checked");
	if (is_checked) {
		if (g_autosave_interval_id != null) {
			clearInterval(g_autosave_interval_id);
		}
		g_autosave_interval_id = setInterval(AutoSaveDeck, 1000 * 60 * 2);
		g_autoupdate_deck = true;
	}
	else {
		clearInterval(g_autosave_interval_id);
		g_autoupdate_deck = false;
	}
}

/*
 * Updates deck if any container has moved since previous autosave
 */
function AutoSaveDeck () {
	// only save if anything has moved
	if (!g_container_is_dirty) {
		return;
	}

	SaveLocalState();
	g_remote_object.SubmitAllData('update_deck', function () {
		UpdateAllDeckTotals();
	});

	g_container_is_dirty = false;
}

